import { useAuth0 } from '@auth0/auth0-react';
import { Loader } from 'braid-design-system';

export const UserProfileMenuItemLabel = () => {
  const { user, isLoading } = useAuth0();
  return isLoading ? (
    <Loader size="xsmall" />
  ) : (
    <>{user?.name ? user.name : 'Profile'}</>
  );
};
